import angular from 'angular';
import preloaderDot from './preloaderDot';
import preloaderDotInline from './preloaderDotInline';

export default angular
  .module('components.preloaderDot', [])
  .component('preloaderDot', preloaderDot)
  .component('preloaderDotInline', preloaderDotInline).name;
